import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import AuthService from "../../../api/services/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../customComponents/CustomAlertMessage";
import { Helmet } from "react-helmet-async";
import LoaderHelper from "../../../customComponents/Loading/LoaderHelper";
import { ProfileContext } from "../../../context/ProfileProvider";
import "../AnnouncmentManagement/Annoucement.css";

const NotificationPage = (props) => {
  const { setRefreshNotification, refreshNotification } = useContext(ProfileContext)

  const [notifications, setNotifications] = useState([]);
  const [unseenCount, setUnseenCount] = useState(0);

  useEffect(() => {
    handleNotifications();
  }, [])


  const handleNotifications = async () => {
    const result = await AuthService.notifications()
    if (result.success) {
      try {
        setNotifications(result?.data);
        setUnseenCount(result?.counts?.unseen || 0)
      } catch (error) {
        alertErrorMessage(result?.message)
      }
    }
    else {
      alertErrorMessage(result.message)
    }
  }
  const handleMarkAll = async () => {
    const result = await AuthService.markasAllRead()
    if (result.success) {
      try {
        setRefreshNotification(!refreshNotification)
        alertSuccessMessage(result?.message)
        handleNotifications();
      } catch (error) {
        alertErrorMessage(result?.message)
      }
    }
    else {
      alertErrorMessage(result.message)
    }
  }

  const handleMarkRead = async (notificationId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.markasRead(notificationId);
      LoaderHelper.loaderStatus(false);
      if (result?.success) {
        setRefreshNotification(!refreshNotification)
        handleNotifications();
        alertSuccessMessage("Notification marked as read")
      } else {
        alertErrorMessage("Something went wrong while fetching notifications.");
      }
    } catch (err) {
      LoaderHelper.loaderStatus(false);
      alertErrorMessage("Error loading notifications.");
    }
  };



  return (
    <>
      <Helmet>
        <title> Zillion Exchange Trade | The world class new generation crypto asset exchange</title>
      </Helmet>
 

      <div className="dashboard_right">
        <div className="dashboard_listing_section Overview_mid">
          <div className="kyc_approval_s activity_logs notification-premium-page">
            <div className="cnt">
              <div className="notification-premium-hero">
                <div className="notification-premium-hero__copy">
                  <span className="notification-premium-hero__eyebrow">Inbox</span>
                  <h3 style={{color: "var(--text-color)"}}>Notifications</h3>
                  <p>Track platform updates, account activity, and important alerts in one polished inbox.</p>
                </div>
                <div className="notification-premium-hero__actions">
                  <div className="notification-premium-stat">
                    <span className="notification-premium-stat__label">Unread</span>
                    <strong>{unseenCount}</strong>
                  </div>
                  {unseenCount > 0 && (
                    <button
                      onClick={handleMarkAll}
                      className="notification-premium-markall"
                    >
                      Mark all as read
                    </button>
                  )}
                </div>
              </div>
              {notifications?.length > 0 ? (
                <div className="notification-premium-list-wrap">
                  <div className="notification-premium-list-head">
                    <h4>Latest Updates</h4>
                    <span>{notifications.length} notification{notifications.length > 1 ? "s" : ""}</span>
                  </div>
                  <div className="notification-premium-list">
                    {notifications.map((item) => (
                      <article
                        key={item._id}
                        className={`notification-premium-card ${item?.isSeen === false ? "is-unread" : "is-read"}`}
                      >
                        <div className="notification-premium-card__glow" />
                        <div className="notification-premium-card__header">
                          <div className="notification-premium-card__titleWrap">
                            <span className="notification-premium-card__icon">
                              <i className="ri-notification-3-line"></i>
                            </span>
                            <div>
                              <h4>{item?.title}</h4>
                              <div className="notification-premium-card__meta">
                                <span>{moment(item?.createdAt).fromNow()}</span>
                                {item?.isSeen === false && <span className="notification-premium-unread-dot">Unread</span>}
                              </div>
                            </div>
                          </div>
                          {item?.isSeen === false && (
                            <button
                              type="button"
                              className="notification-premium-read-btn"
                              onClick={() => handleMarkRead(item._id)}
                            >
                              Mark as read
                            </button>
                          )}
                        </div>

                        <p className="notification-premium-card__message">{item?.message}</p>

                        <div className="notification-premium-card__footer">
                          <span className="notification-premium-card__timestamp">
                            {moment(item?.createdAt).format("DD MMM YYYY, hh:mm A")}
                          </span>
                          {item?.link && (
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="notification-premium-link"
                            >
                              Learn more
                              <i className="ri-arrow-right-up-line"></i>
                            </a>
                          )}
                        </div>
                      </article>
                    ))}
                  </div>
                </div>
              ) : (
                <div className='d-flex justify-content-center notification-premium-empty-wrap'>
                  <div className="no_data_outer notification-premium-empty fullwidth">
                    <div className="table-responsive">
                    <div className="nodata_bl">
                      <div className="no_data_vector">
                        <img src="/images/no_data_vector.svg" className="dark_img" alt="no-data" /><img src="/images/no_data_vector_light.png" className="light_img" alt="no-data"/>
                      </div>
                      <h4>No Notifications Yet</h4>
                      <p>When new updates arrive, they will appear here in your activity inbox.</p>
                    </div>
                    </div>
                  </div>
                </div>)}

            </div>
          </div>



          {/* 
          <div className="dashboard_right_side profileslider">

            <div className="slider dashboard_slider">
              <Slider {...bannerSettings}>
                <div className="banner_img_add">

                  <div className="cnt_slider_f">
                    <h6>Cvtrade Lending Protocol</h6>
                    <p>Borrow Low, Earn High</p>
                  </div>

                  <div className="cv_trade_img">
                    <img src="/images/cvtrade_bitcoin.svg" alt="bitcoin" />
                  </div>

                </div>
                <div className="banner_img_add">

                  <div className="cnt_slider_f">
                    <h6>Cvtrade Lending Protocol</h6>
                    <p>Borrow Low, Earn High</p>
                  </div>

                  <div className="cv_trade_img">
                    <img src="/images/cvtrade_bitcoin.svg" alt="bitcoin" />
                  </div>

                </div>

                <div className="banner_img_add">

                  <div className="cnt_slider_f">
                    <h6>Cvtrade Lending Protocol</h6>
                    <p>Borrow Low, Earn High</p>
                  </div>

                  <div className="cv_trade_img">
                    <img src="/images/cvtrade_bitcoin.svg" alt="bitcoin" />
                  </div>

                </div>

                <div className="banner_img_add">

                  <div className="cnt_slider_f">
                    <h6>Cvtrade Lending Protocol</h6>
                    <p>Borrow Low, Earn High</p>
                  </div>

                  <div className="cv_trade_img">
                    <img src="/images/cvtrade_bitcoin.svg" alt="bitcoin" />
                  </div>

                </div>

                <div className="banner_img_add">

                  <div className="cnt_slider_f">
                    <h6>Cvtrade Lending Protocol</h6>
                    <p>Borrow Low, Earn High</p>
                  </div>

                  <div className="cv_trade_img">
                    <img src="/images/cvtrade_bitcoin.svg" alt="bitcoin" />
                  </div>

                </div>
              </Slider>
            </div>

          </div> */}



        </div>

      </div>

    </>
  );
};

export default NotificationPage;
